var base = require('settings/profile/update-contact-information');
import {VueEditor, Quill} from "vue2-editor";
import {ImageDrop} from 'quill-image-drop-module';
import ImageResize from 'quill-image-resize-module';
import FontPicker from 'font-picker-vue';
import Datepicker      from 'vuejs-datepicker';
Vue.use(FontPicker);

Quill.register('modules/imageDrop', ImageDrop)
Quill.register('modules/imageResize', ImageResize)
Vue.component('spark-update-contact-information', {
    mixins: [base],
    props:['user'],
    components: {
        VueEditor,
        fontpicker: FontPicker,
        Datepicker,
    },
    data() {
        return {
            form: $.extend(true, new SparkForm({
                signatureVal : '',
                show_powered_by : 1,
                title                : '',
                name                 : '',
                email                : '',
                notification_settings: {
                    chosen_frequency: '',
                    frequency       : {
                        instant: false,
                        daily  : false,
                        weekly : false
                    },
                    content         : {
                        file_data           : false,
                        documents_and_photos: false,
                        mentions            : false,
                        comments_and_logs   : false
                    },
                    highlights         : {
                        yesterday           : false,
                        monthly             : false,
                        we_miss_you            : false
                    }
                },
                editorSettings: {
                    modules: {
                        imageDrop: true,
                        imageResize: {
                            modules: ['Resize', 'DisplaySize', 'Toolbar']

                        }
                    }
                },
            }), Spark.forms.updateContactInformation),
            userName: '',
            fontOptions: { },
            fontFamily: 'Open Sans',
        };
    },
    created() {
        this.fetchNotificationSettings();
        this.form.signatureVal = this.user.signature;
        this.form.show_powered_by = this.user.show_powered_by;
    },

    methods: {
        fetchNotificationSettings() {
            axios.get(route('api.settings.email-notification-settings'))
                .then(({data}) => {
                    if (data) {
                        this.form.notification_settings.chosen_frequency             = data.frequency;
                        this.form.notification_settings.frequency[data.frequency]    = true;
                        this.form.notification_settings.content.file_data            = data.content_file_data ? true : false;
                        this.form.notification_settings.content.documents_and_photos = data.content_documents_and_photos ? true : false;
                        this.form.notification_settings.content.mentions             = data.content_mentions ? true : false;
                        this.form.notification_settings.content.comments_and_logs    = data.content_comments_and_logs ? true : false;
                        this.form.notification_settings.highlights.yesterday             = data.yesterday_highlights ? true : false;
                        this.form.notification_settings.highlights.monthly             = data.monthly_highlights ? true : false;
                        this.form.notification_settings.highlights.we_miss_you             = data.we_miss_you ? true : false;
                    }
                });
        },

        frequencyChoice(chosenOption) {
            if (this.form.notification_settings.chosen_frequency === chosenOption && this.form.notification_settings.frequency[chosenOption] === true) {
                this.form.notification_settings.chosen_frequency = '';
            } else {
                this.form.notification_settings.chosen_frequency = chosenOption;
            }

            for (let key in this.form.notification_settings.frequency) {
                this.form.notification_settings.frequency[chosenOption] = !this.form.notification_settings.frequency[chosenOption];
                if (key !== chosenOption) {
                    this.form.notification_settings.frequency[key] = false;
                }
            }
        },
        editSignature(){
            $('#signAndAccept').modal('show');
        },
        saveSignature(){
            axios.post(route('api.settings.edit-signature'),{
                signature: this.form.signatureVal,
                show_powered_by: this.form.show_powered_by,
            }).then(({data}) => {
                    $('#signAndAccept').modal('hide');
                });
        },
        handleImageAdded: function (file, Editor, cursorLocation, resetUploader) {
            // An example of using FormData
            // NOTE: Your key could be different such as:
            // formData.append('file', file)
            const formData = new FormData();
            formData.append("image", file);
            axios.post(route('api.editor-image-upload'), formData).then(result => {
                const url = result.data.data; // Get url from response
                Editor.insertEmbed(cursorLocation, "image", url);
                resetUploader();
            }).catch(err => {
                console.log(err);
            });
        },
        handleRemoveImage: function (file, Editor, cursorLocation, resetUploader){
            axios.post(route('api.editor-image-remove'), {'filePath':file}).then(result => {
                console.log('remove',result);
            }).catch(err => {
                console.log(err);
            });
        },

        mySignature() {
            let self = this;
            axios.get(route('proposal-template.get-user-for-signature')).then(({data}) => {
                if(data.status == 'success') {
                    let userName = data.user_name;
                    userName = userName.toLowerCase().replace(/\b[a-z]/g, function(letter) {
                        return letter.toUpperCase();
                    });
                    self.userName = userName;
                    if(data.font_family) {
                        self.fontFamily = data.font_family;
                    }
                }
            });

            $("#my_signature_modal").modal("show");
        },

        updateFont(event) {
            let self = this;
            self.fontFamily = event.family;
        },

        updateUserSignature() {
            let self = this;
            let mySignature = '<span style="font-family:' + self.fontFamily + ' !important;">' + self.userName + '</span>';

            let params = {
                font_family: self.fontFamily,
                my_signature: mySignature
            };

            axios.post(route('proposal-template.update-user-signature'), params).then(response => {
                if(response.data.status == 'success') {
                    $("#my_signature_modal").modal("hide");
                    self.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                }
            });
        },
    }
});
